import * as React from 'react';
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridRowClickEvent,
  GridRowDoubleClickEvent,
  GridSortChangeEvent,
  GRID_COL_INDEX_ATTRIBUTE, GridCustomRowProps, GridItemChangeEvent, GridCustomCellProps, GridNoRecords
} from '@progress/kendo-react-grid';
import {EditDescriptor, NavigatableMode, useTableKeyboardNavigation} from '@progress/kendo-react-data-tools';
import { useInternationalization } from '@progress/kendo-react-intl';
import {classNames, SvgIcon} from '@progress/kendo-react-common';
import { convertDateFormat, getName, formatBytes } from '../helpers/helperMethods';
import {Input} from "@progress/kendo-react-inputs";
import { Button } from '@progress/kendo-react-buttons';
import {useEffect} from "react";

const DateCreatedCell  = (props: GridCellProps) => {
  const intl = useInternationalization();

  const field: string = props.field || '';
  const date: Date = props.dataItem[field];
  const navigationAttributes = useTableKeyboardNavigation(props.id);

  return (
      <td
          {...{ [GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex }}
          {...navigationAttributes}
      >
        {date === null ? '' : convertDateFormat(date, intl)}
      </td>
  );
};

const GridContext = React.createContext<any>({});

const NameCommandCell = (props: GridCustomCellProps) => {
  const { enterEdit, remove, add, discard, update, cancel, save, editField } = React.useContext(GridContext);

  return (
      <NameCell
          {...props}
          edit={enterEdit}
          remove={remove}
          add={add}
          discard={discard}
          update={update}
          cancel={cancel}
          save={save}
          editField={editField}
      />
  );
};

const NameCell = (props: any) => {
  const [renameValue, setRenameValue] = React.useState(props.dataItem.name);
  const [svgIcon, setsvgIcon] = React.useState(null);
  const navigationAttributes = useTableKeyboardNavigation(props.id);

  useEffect(() => {
    if (props?.dataItem && props?.dataItem?.icon) {
      setsvgIcon(props.dataItem.icon.svgIcon)
    }
  }, [props?.dataItem])

  const handleInputChange = (e) => {
    setRenameValue(e.target.value)
  }

  return (
      // <td
      //     {...{[GRID_COL_INDEX_ATTRIBUTE]: props.columnIndex}}
      //     {...navigationAttributes}
      // >
      <td {...props.tdProps} className={classNames('k-command-cell', ...props.className)}>
        {props.isInEdit &&
            <>
              <Input
                  // maxLength={40}
                  autoFocus
                  value={renameValue}
                  style={{width: '60%', marginRight: '5px'}}
                  className={'k-textbox'}
                  onChange={handleInputChange}
              />
              <Button
                  themeColor={'primary'}
                  style={{width: '15%', marginRight: '5px'}}
                  onClick={(e) => props.save(e, props.dataItem, renameValue)}
              >
                {'Save'}
              </Button>
              <Button
                  themeColor={'primary'}
                  style={{width: '15%'}}
                  onClick={(e) => props.cancel(e, props.dataItem)}
              >
                {'Cancel'}
              </Button>
            </>
        }
        {!props.isInEdit &&
            <>
              <SvgIcon icon={svgIcon} style={{marginRight: '5px'}}/>
              {renameValue}
            </>
        }
      </td>
  );
};

export const GridView = (props) => {
  const RowRender = (trElement, dataItem) => {
    const trProps = {
      onContextMenu: (event) => {
        event.preventDefault()
        handleContextMenu(event, dataItem);
      }
    }
    return React.cloneElement(trElement, { ...trProps }, trElement.props.children);
  };

  const handleOnSortChange = (event: GridSortChangeEvent) => {
    props.onSortChange({
      sort: event.sort,
      event: event
    });
  };

  const handleSelectionChange = (event: GridRowClickEvent) => {
    props.onSelectionChange(event);
  };

  const handleMultipleSelection = (event) => {
    props.onMultipleSelection(event);
  };

  const handleDoubleClick = (event: GridRowDoubleClickEvent) => {
    if (!event.dataItem.name.toLowerCase().includes(".zip")) {
      props.onDoubleClick(event);
    }
  };

  const handleContextMenu = (event: React.MouseEvent<HTMLDivElement, MouseEvent>, dataItem) => {
    props.onContextMenu({
      dataItem: dataItem?.dataItem ? dataItem.dataItem : null,
      event: event
    });
  };

  const itemChange = (event: GridItemChangeEvent) => {
    console.log(event)
  }

  const cancel = (event, dataItem) => {
    props.onCancelRename({
      event: event,
      dataItem: dataItem
    });
  };

  const save = (event, dataItem, renameValue) => {
    props.onSaveRename({
      event: event,
      dataItem: dataItem,
      value: renameValue
    });
  };

  return (
      <>
        {/*{props.data?.data?.length > 0 &&*/}
        <GridContext.Provider value={{ cancel, save }}>
          <Grid
              data={props.data}
              editable={true}
              edit={props.edit}
              key={'id'}
              rowRender={RowRender}
              onItemChange={itemChange}
              // rows={{ data: CustomRow }}
              className={'k-filemanager-grid k-grid-display-block k-editable'}
              style={{ height: '500px' }}
              fixedScroll={true}
              // scrollable={{true}}
              // navigatable={true}
              navigatable={{ mode: 'inline' as NavigatableMode }}
              sortable={{
                allowUnsort: false
              }}
              sort={props.sort}
              selectedField={'selected'}
              selectable={{ enabled: true, cell: false, drag: true, mode: 'multiple' }}
              dataItemKey={props.dataItemKey}
              onRowClick={handleSelectionChange}
              onSelectionChange={handleMultipleSelection}
              onSortChange={handleOnSortChange}
              onRowDoubleClick={handleDoubleClick}
          >
            <GridNoRecords><div onContextMenu={(event) => {handleContextMenu(event, null)}} style={{width: '100%', height: '100%'}}>No Files Exist for this folder. Drop files here to add.</div></GridNoRecords>
            <Column field="id" title="Id" width="50px" editable={false} hidden={true}/>
            <Column field='path' title='Name' cells={{
              data: NameCommandCell
            }}
            />
            <Column field='dateCreated' title='Date Created' cells={{data: DateCreatedCell}} />
          </Grid>
        </GridContext.Provider>
        {/*}*/}
      </>
  );
}
